"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Feedback;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_hook_form_1 = require("react-hook-form");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const pro_solid_svg_icons_2 = require("@fortawesome/pro-solid-svg-icons");
const useDevice_1 = require("../../hooks/useDevice");
const useAppMessage_1 = require("../../hooks/useAppMessage");
const AppText_1 = require("../../component/AppText");
const InputForm_1 = require("../../component/InputForm");
const GradientButton_1 = require("../../component/GradientButton");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const ErrorMessege_1 = require("../../component/ErrorMessege");
const DiscoverFooter_1 = __importDefault(require("../Discover/DiscoverFooter"));
const application_host_1 = require("../../common/application-host");
const sourceOptions = [
    'Recommendation from a friend / colleague',
    'Mac App Store',
    'Google or another search engine',
    'Social media post',
    'Advertisement'
];
const featureOptions = [
    'Document summarization quality',
    'Speed',
    'Notes',
    'Sharing',
    'Integration with workflow',
    ...(window.navigator.userAgent.includes('desk.summaraizer') ? ['macOS app'] : []),
];
function Feedback() {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const { control, handleSubmit, formState: { errors } } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            email: '',
            source: '',
            featurePreferences: [],
            rating: 0,
            comments: ''
        }
    });
    const onSubmit = (0, react_1.useCallback)(async (data) => {
        try {
            const response = await fetch(`${application_host_1.APP_HOST}/api/v1/feedbacks`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                setIsSubmitted(true);
            }
            else {
                showNotification('Error', 'Failed to submit feedback. Please try again.', 'error');
            }
        }
        catch (error) {
            showNotification('Error', 'Error submitting feedback. Please try again later.', 'error');
        }
    }, [showNotification]);
    if (isSubmitted) {
        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.successContainer, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.thankYouTitle, children: "Thank you for your feedback!" }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.appreciationText, children: "Your feedback helps us improve our summarization technology." })] }), (0, jsx_runtime_1.jsx)(DiscoverFooter_1.default, {})] }));
    }
    return ((0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { style: styles.container, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.content, isMobileScreen && styles.contentMobile], children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.title, children: "Help us improve Summaraizer" }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.form, children: [(0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "email", rules: { required: true, pattern: constants_1.EMAIL_REG }, render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.formGroup, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.label, children: "Email *" }), (0, jsx_runtime_1.jsx)(InputForm_1.InputForm, { id: "email", placeholder: "john.doe@xyz.com", value: value, onChangeText: onChange }), (0, jsx_runtime_1.jsx)(ErrorMessege_1.ErrorMessege, { msg: "Please enter a valid email address", isError: Boolean(errors.email) })] })) }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "source", render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.formGroup, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.label, children: "How did you find out about Summaraizer?" }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.radioGroup, children: sourceOptions.map((option) => ((0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => onChange(option), style: styles.radioButton, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                                                            styles.radio,
                                                            value === option && styles.radioSelected
                                                        ] }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.radioLabel, children: option })] }, option))) })] })) }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "featurePreferences", render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.formGroup, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.label, children: "Could you please tell us what you like the most about Summaraizer?" }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.checkboxGroup, children: featureOptions.map((option) => ((0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => {
                                                    const newValue = value.includes(option)
                                                        ? value.filter(item => item !== option)
                                                        : [...value, option];
                                                    onChange(newValue);
                                                }, style: styles.checkboxButton, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                                                            styles.checkbox,
                                                            value.includes(option) && styles.checkboxSelected
                                                        ], children: value.includes(option) && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_2.faCheck, color: colors_1.Colors.white, size: 12 })) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.checkboxLabel, children: option })] }, option))) })] })) }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "rating", rules: { required: true, min: 1 }, render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.formGroup, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.label, children: "How likely would you recommend Summaraizer to your friends? *" }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.starsContainer, children: [1, 2, 3, 4, 5].map((star) => ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => onChange(star), style: styles.starButton, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: star <= value ? pro_solid_svg_icons_1.faStar : pro_light_svg_icons_1.faStar, color: star <= value ? colors_1.Colors.ORANGE : colors_1.Colors.DARK_200, size: 24 }) }, star))) }), (0, jsx_runtime_1.jsx)(ErrorMessege_1.ErrorMessege, { msg: "Please select a rating", isError: Boolean(errors.rating) })] })) }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "comments", render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.formGroup, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.label, children: "Any other comments?" }), (0, jsx_runtime_1.jsx)(InputForm_1.InputForm, { id: "comments", placeholder: "Share your experience ...", value: value, onChangeText: onChange })] })) }), (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: "Submit Feedback", onPress: handleSubmit(onSubmit), fullWidth: true })] })] }), (0, jsx_runtime_1.jsx)(DiscoverFooter_1.default, {})] }));
}
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors_1.Colors.DARK_700,
        marginTop: 64,
    },
    content: {
        maxWidth: 768,
        width: '100%',
        alignSelf: 'center',
        padding: 24,
        gap: 32,
    },
    contentMobile: {
        padding: 16,
    },
    title: {
        color: colors_1.Colors.white,
        fontSize: 24,
        fontWeight: '700',
        lineHeight: 29.05,
    },
    form: {
        gap: 24,
    },
    formGroup: {
        gap: 8,
    },
    label: {
        color: colors_1.Colors.white,
        fontSize: 18,
        fontWeight: '500',
    },
    successContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 24,
        gap: 16,
    },
    thankYouTitle: {
        color: colors_1.Colors.white,
        fontSize: 24,
        fontWeight: '700',
        textAlign: 'center',
    },
    appreciationText: {
        color: colors_1.Colors.DARK_200,
        fontSize: 16,
        textAlign: 'center',
    },
    starsContainer: {
        flexDirection: 'row',
        gap: 8,
        justifyContent: 'flex-start',
        paddingVertical: 8,
    },
    starButton: {
        padding: 8,
    },
    radioGroup: {
        gap: 12,
    },
    radioButton: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingVertical: 8,
    },
    radio: {
        width: 20,
        height: 20,
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colors_1.Colors.DARK_200,
    },
    radioSelected: {
        borderColor: colors_1.Colors.PRIMARY_300,
        backgroundColor: colors_1.Colors.PRIMARY_300,
    },
    radioLabel: {
        color: colors_1.Colors.white,
        fontSize: 16,
    },
    checkboxGroup: {
        gap: 12,
    },
    checkboxButton: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingVertical: 8,
    },
    checkbox: {
        width: 20,
        height: 20,
        borderRadius: 4,
        borderWidth: 2,
        borderColor: colors_1.Colors.DARK_200,
        alignItems: 'center',
        justifyContent: 'center',
    },
    checkboxSelected: {
        borderColor: colors_1.Colors.PRIMARY_300,
        backgroundColor: colors_1.Colors.PRIMARY_300,
    },
    checkboxLabel: {
        color: colors_1.Colors.white,
        fontSize: 16,
    },
});
